import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../frame/services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const auth = this.authService.authValue;

        if (auth && auth.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${auth.access_token}`
                }
            });
        }

        return next.handle(request);
    }
}
